import { Link } from 'react-router-dom';

import './Home.css';
import Disclaimer from '../../components/Disclaimer';
import DonateButton from '../../components/DonateButton';
import DonateButtonLg from '../../components/DonateButtonLg';
import Footer from '../../components/Footer';
import logo from '../../images/logo.svg';
import logoMark from '../../images/logo-mark.svg';

function Home() {
  return (
    <div className="Home">
      <header>
        <div className="absolute left-0 z-10 w-full bg-marine-blue header-background-banner"></div>
        <div className="absolute left-0 z-20 w-full bg-center bg-no-repeat capitol-background"></div>
        <div className="absolute z-30 Home__shield-logo-mark left-1/2">
          <img src={logo} alt="The Shield PAC Logo" />
        </div>
        <nav className="absolute top-0 right-0 z-40 w-full pt-3 pr-2 md:pt-6 md:pr-6">
          <div className="flex items-center justify-between w-full">
            <div className="flex items-center pt-3 pl-6">
              <Link to="/">
                <img
                  src={logoMark}
                  alt="The Shield PAC Logo"
                  width={36}
                  height={45}
                />
              </Link>
              <Link
                to="/about"
                className="inline-block px-3 py-1 text-base font-bold tracking-wide text-white uppercase"
              >
                About <span className="hidden md:inline-block">Shield PAC</span>
                <div className="Navigation__link-border"></div>
              </Link>
            </div>
            <DonateButton />
          </div>
        </nav>
      </header>
      <article>
        <section
          className="title md:mx-auto md:max-w-3xl"
          aria-labelledby="title"
        >
          <h1
            className="mb-5 font-sans text-6xl font-bold text-center md:mb-12 md:px-4"
            id="title"
          >
            The Last Line of Defense – Protect Moderate Democrats
          </h1>
          <div className="w-full text-center">
            <DonateButtonLg />
          </div>
        </section>
        <main>
          <section
            className="w-full content bg-gray-50 px-2.5 md:px-6 pt-18 pb-4 md:pb-7 -mt-7 text-xl text-center leading-extra-relaxed"
            aria-labelledby="about"
          >
            <div className="lg:mx-auto lg:max-w-4xl lg:px-12" id="about">
              <p className="font-serif">
                <em className="font-italic">Moderate</em> Democrats delivered
                the House majority by flipping hard-to-win seats from red to
                blue. That means they will be on the front lines in 2022: the
                GOP’s top targets. Shield PAC will build a protective barrier to
                defend swing-seat Democrats from culture war attacks that can be
                politically fatal. These Members are our last line of defense to
                save our democracy.
              </p>
              <p className="mb-3 font-serif">
                <Link to="/about" className="font-sans font-bold text-cerulean">
                  More About Shield PAC
                </Link>
              </p>
              <p className="font-serif text-lg">
                For questions or press inquiries, please email{' '}
                <a href="mailto:info@shieldpac.org">info@shieldpac.org</a>.
              </p>
              <p className="font-serif text-lg">
                Donations can be mailed to:<br />
                Shield PAC, 1025 Connecticut Ave. NW, Suite 400, Washington, DC 20036
              </p>
            </div>
          </section>
        </main>
        <section
          className="w-full content bg-gray-50 px-2.5 md:px-6 pb-12 md:pb-20"
          aria-labelledby="contact"
        >
          <div className="lg:mx-auto lg:max-w-4xl lg:px-12" id="contact">
            <Disclaimer />
          </div>
        </section>
        <Footer />
      </article>
    </div>
  );
}

export default Home;
